import React from 'react';
import { Link } from 'react-router-dom';
import { Product } from '../types/types';
import { PRODUCT_CATEGORIES } from '../data/constants';
import PetIcon from './icons/PetIcons';
import '../styles/ProductCard.css';

interface ProductCardProps {
  product: Product;
}

const PLACEHOLDER_IMG = '/images/products/placeholder.svg';

const ProductCard: React.FC<ProductCardProps> = ({ product }) => {
  const category = PRODUCT_CATEGORIES.find(c => c.value === product.category);
  const isContoso = product.tags?.includes('contoso');

  const handleImgError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.onerror = null;
    e.currentTarget.src = PLACEHOLDER_IMG;
  };

  return (
    <Link to={`/product/${product.id}`} className={`product-card${isContoso ? ' product-card--contoso' : ''}`}>
      <div className="product-card-image">
        <img
          src={product.imageUrl || PLACEHOLDER_IMG}
          alt={product.name}
          loading="lazy"
          onError={handleImgError}
        />
        {isContoso && <span className="contoso-badge">🏷️ Contoso Clearance</span>}
        {product.featured && !isContoso && <span className="featured-badge">⭐ Featured</span>}
        {!product.inStock && <span className="out-of-stock-badge">Out of Stock</span>}
        <div className="product-card-overlay">
          <span className="view-details">View Details →</span>
        </div>
      </div>

      <div className="product-card-content">
        <div className="product-card-meta">
          <span className="product-category">
            {category?.icon} {category?.label || product.category}
          </span>
          <span className="product-pet-type">
            <PetIcon type={product.petType} size={16} /> {product.petType}
          </span>
        </div>

        <h3 className="product-card-title">{product.name}</h3>
        <p className="product-card-description">{product.description}</p>

        <div className="product-card-footer">
          <span className="product-price">${product.price.toFixed(2)}</span>
          <span className="product-rating">
            {'★'.repeat(Math.round(product.rating))}{'☆'.repeat(5 - Math.round(product.rating))}
            <span className="rating-value">{product.rating.toFixed(1)}</span>
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
